module.exports = __webpack_public_path__ + "img/GoldDownIconDemoBlancFichier 17@4x-8.5060982e.png";